import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { TreeViewItem } from './component/TreeViewItem';
import { NewItemHandler } from './component/NewItemHandler';
import { getFormTypeFromLevel } from './helpers';
import React from 'react';
export var CustomFieldFormType;
(function (CustomFieldFormType) {
    CustomFieldFormType[CustomFieldFormType["Section"] = 1] = "Section";
    CustomFieldFormType[CustomFieldFormType["Subsection"] = 2] = "Subsection";
    CustomFieldFormType[CustomFieldFormType["Field"] = 3] = "Field";
})(CustomFieldFormType || (CustomFieldFormType = {}));
const getFormTypeAndNullHandlers = (level) => {
    switch (level) {
        case 1:
            return {
                formType: CustomFieldFormType.Section,
                nullHandlers: ['onFieldChange', 'onSubsectionChange', 'onSectionChange']
            };
        case 2:
            return {
                formType: CustomFieldFormType.Subsection,
                nullHandlers: ['onFieldChange', 'onSubsectionChange']
            };
        case 3:
            return {
                formType: CustomFieldFormType.Field,
                nullHandlers: ['onFieldChange']
            };
        default:
            return {
                formType: CustomFieldFormType.Field,
                nullHandlers: []
            };
    }
};
export const TreeView = ({ data, sectionId, subsectionId, fieldId, onFieldChange, onSectionChange, onSubsectionChange, onNewItemSelect, onEdit }) => {
    const handleNewItemSelect = useCallback((level) => {
        const { formType, nullHandlers } = getFormTypeAndNullHandlers(level);
        if (nullHandlers.includes('onFieldChange'))
            onFieldChange(null);
        if (nullHandlers.includes('onSectionChange'))
            onSectionChange(null);
        if (nullHandlers.includes('onSubsectionChange'))
            onSubsectionChange(null);
        onNewItemSelect(formType);
    }, [onFieldChange, onSectionChange, onSubsectionChange, onNewItemSelect]);
    const renderTree = useCallback((nodes, level, isField = false) => (_jsx(_Fragment, { children: nodes.map((node) => {
            var _a, _b, _c, _d;
            return (_jsx(React.Fragment, { children: _jsxs("div", { children: [_jsx(TreeViewItem, { node: node, level: level, isField: isField, sectionId: sectionId, subsectionId: subsectionId, fieldId: fieldId, isLast: false, onFieldChange: onFieldChange, onSectionChange: onSectionChange, onSubsectionChange: onSubsectionChange, onEdit: () => onEdit(node, getFormTypeFromLevel(level)) }), _jsxs("div", Object.assign({ className: `tree-item-content ${((level === 1 && sectionId === node.id) ||
                                (level > 1 && subsectionId === node.id)) &&
                                'expanded'}` }, { children: [('subSections' in node && !!((_a = node.subSections) === null || _a === void 0 ? void 0 : _a.length)) ||
                                    ('fields' in node && !!((_b = node.fields) === null || _b === void 0 ? void 0 : _b.length)) ? (_jsxs(_Fragment, { children: ['subSections' in node && !!((_c = node.subSections) === null || _c === void 0 ? void 0 : _c.length) && (_jsx("div", { children: renderTree(node.subSections, level + 1) })), 'fields' in node && !!((_d = node.fields) === null || _d === void 0 ? void 0 : _d.length) && (_jsx("div", { children: renderTree(node.fields, level + 1, true) }))] })) : null, _jsx(NewItemHandler, { level: level + 1, onSelect: () => handleNewItemSelect(level + 1) })] }))] }) }, node.id));
        }) })), [
        sectionId,
        subsectionId,
        fieldId,
        onFieldChange,
        onSectionChange,
        onSubsectionChange,
        onEdit,
        handleNewItemSelect
    ]);
    const memoizedTree = useMemo(() => renderTree(data, 1), [data, renderTree]);
    return (_jsxs("div", { children: [memoizedTree, _jsx(NewItemHandler, { level: 1, onSelect: () => handleNewItemSelect(1) })] }));
};
